// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._wG9l24pfFarpqupqg0B{display:flex;flex-direction:column;gap:15px}.FceCo2cFuiX6N_S1jdKQ{padding:16px 0}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/integrations/pages/integrationSettings/IntegrationZohoSettings/ui/IntegrationZohoSettingsSync/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,qBAAA,CACA,QAAA,CAEF,sBACE,cAAA","sourcesContent":[".root {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n.titledRow {\n  padding: 16px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `_wG9l24pfFarpqupqg0B`,
	"titledRow": `FceCo2cFuiX6N_S1jdKQ`
};
export default ___CSS_LOADER_EXPORT___;
